<template>
  <footer class="site-footer">
    <div class="container">
      <div v-if="$route.name !== 'Seja sócio'" class="site-footer__cta">
        <p class="site-footer__cta-text">Ainda não é sócio? Fortaleça quem defende a sua categoria.</p>
        <router-link :to="{ name: 'Seja sócio' }" class="text-link text-link--on-dark">Saiba como se associar</router-link>
      </div>

      <div class="site-footer__grid">
        <div class="site-footer__brand">
          <img src="@/assets/logo_white.svg" alt="SEEB Uberlândia" class="site-footer__logo" />
          <p class="site-footer__name">
            Sindicato dos Empregados em Estabelecimentos Bancários de Uberlândia e Região
          </p>
          <p class="site-footer__president">
            Presidente <strong>Edivaldo Dias Cunha</strong>
          </p>
        </div>

        <nav class="site-footer__nav" aria-labelledby="footer-nav-title">
          <h2 id="footer-nav-title" class="site-footer__heading">O sindicato</h2>
          <ul class="site-footer__links">
            <li><router-link :to="{ name: 'Notícias' }">Notícias</router-link></li>
            <li><router-link :to="{ name: 'Acordos e Convenções' }">Acordos e convenções</router-link></li>
            <li><router-link :to="{ name: 'Convênios' }">Convênios</router-link></li>
            <li><router-link :to="{ name: 'Clube' }">Clube</router-link></li>
            <li><router-link :to="{ name: 'Galeria' }">Galeria</router-link></li>
            <li>
              <a href="http://carteira.bancariosuberlandia.org.br" target="_blank" rel="noopener">
                Minha carteirinha
              </a>
            </li>
          </ul>
        </nav>

        <div class="site-footer__contact">
          <h2 class="site-footer__heading">Contato</h2>
          <address class="site-footer__address">
            <p>R. Duque de Caxias, 95, Centro<br />Uberlândia - MG, 38400-142</p>
            <p>
              <a href="https://wa.me/553432367277" target="_blank" rel="noopener" class="site-footer__phone site-footer__whats">
                <img src="@/assets/logo-whatsapp.png" alt="" width="18" height="18" />
                (34) 3236 7277
              </a><br />
              Fax (34) 3236-3803
            </p>
            <p>
              <a href="mailto:bancariosuberlandia@gmail.com">bancariosuberlandia@gmail.com</a>
            </p>
          </address>
        </div>

        <div class="site-footer__map">
          <iframe
            allowfullscreen
            loading="lazy"
            frameborder="0"
            title="Localização do sindicato no mapa"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.301315466853!2d-48.28290108462407!3d-18.918052487178667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a44454e404aa7f%3A0xceb4948e82d6d372!2sSindicato%20dos%20Bancarios%20de%20Uberl%C3%A2ndia%20e%20Regiao!5e0!3m2!1spt-BR!2sbr!4v1594249370522!5m2!1spt-BR!2sbr"
          />
        </div>
      </div>

      <div class="site-footer__bottom">
        <p>Copyright © {{ year }} Todos os direitos reservados de SEEB</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss">
.web .site-footer {
  background: var(--c-navy-ink);
  color: var(--c-on-dark);
  font-family: var(--font-text);
  font-size: var(--fs-small);
  line-height: 1.6;

  a {
    color: #fff;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  // Chamada final: uma linha, uma ação.
  &__cta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 20px 40px;
    padding: 56px 0;
    border-bottom: 1px solid var(--c-line-dark);
  }

  &__cta-text {
    margin: 0;
    max-width: 28em;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: var(--fs-h3);
    line-height: 1.2;
    color: #fff;
  }

  &__grid {
    display: grid;
    grid-template-columns: minmax(0, 1.25fr) minmax(0, 0.8fr) minmax(0, 1fr) minmax(0, 1.3fr);
    gap: 48px;
    margin-top: 56px;
    padding: 56px 0;
  }

  &__logo {
    display: block;
    height: 56px;
    width: auto;
    margin-bottom: 20px;
  }

  &__name {
    margin: 0 0 16px;
    max-width: 22em;
  }

  &__president {
    margin: 0;
    display: flex;
    flex-direction: column;
    font-size: var(--fs-meta);

    strong {
      color: #fff;
      font-size: var(--fs-small);
      font-weight: 600;
    }
  }

  &__heading {
    margin: 0 0 16px;
    font-family: var(--font-text);
    font-size: var(--fs-small);
    font-weight: 600;
    color: #fff;
  }

  &__links {
    list-style: none;
    margin: 0;
    padding: 0;

    li + li {
      margin-top: 6px;
    }

    a {
      display: inline-block;
      padding: 2px 0;
      color: var(--c-on-dark);
    }

    a:hover {
      color: #fff;
    }
  }

  &__address {
    font-style: normal;

    p {
      margin: 0 0 14px;
    }
  }

  &__phone {
    font-size: 17px;
    font-weight: 600;
  }

  &__map iframe {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 220px;
    border: 0;
    border-radius: var(--radius);
  }

  &__whats {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;

    img {
      display: block;
      width: 18px;
      height: 18px;
      filter: brightness(0) invert(1);
    }
  }

  &__bottom {
    margin-top: 56px;
    padding: 24px 0 32px;
    border-top: 1px solid rgba(255, 255, 255, 0.28);
    font-size: var(--fs-meta);

    p {
      margin: 0;
    }
  }

  @media (max-width: 1099px) {
    &__grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    &__map {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 719px) {
    &__grid {
      grid-template-columns: 1fr;
      gap: 36px;
      padding: 48px 0;
    }

    &__cta .btn {
      width: 100%;
    }

    &__links a {
      padding: 8px 0;
    }

    &__links li + li {
      margin-top: 0;
    }
  }
}
</style>
